import React, { useEffect, useState } from 'react';
import { Tour } from 'antd';
import { useIntl, defineMessages } from 'react-intl';
import useAiAttention from 'src/hooks/useAiAttention';

const messages = defineMessages({
  title: {
    id: 'comp.AiCoachMark.title',
    defaultMessage: 'Meet your AI Agent',
  },
  description: {
    id: 'comp.AiCoachMark.description',
    defaultMessage:
      "You have credits ready to use. Try: “find last month's product photos” or “remove the background on selected assets”.",
  },
});

const SHOW_DELAY_MS = 1800;

/**
 * One-time coach mark pointing at the AI prompt bar (#932). Shows only
 * while useAiAttention is active (agent usable + credits available + not
 * yet engaged); any dismissal — or a first AI prompt — is permanent for
 * this browser via aiAttentionDismissedAtom.
 */
export const AiCoachMark: React.FC = () => {
  const { formatMessage } = useIntl();
  const { active, dismiss } = useAiAttention();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!active) {
      setOpen(false);
      return;
    }
    // wait for the header to settle before anchoring the tour
    const id = window.setTimeout(() => setOpen(true), SHOW_DELAY_MS);
    return () => window.clearTimeout(id);
  }, [active]);

  if (!active) return null;

  return (
    <Tour
      open={open}
      onClose={() => {
        setOpen(false);
        dismiss();
      }}
      steps={[
        {
          title: formatMessage(messages.title),
          description: formatMessage(messages.description),
          target: () => document.querySelector('[data-test="prompt-bar"]') as HTMLElement,
        },
      ]}
    />
  );
};

export default AiCoachMark;
